// extracted by mini-css-extract-plugin
export default {"container":"CV_container__TpPUI","paper":"CV_paper__tHlda","download":"CV_download__cX-hr"};